import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/lo-hp-new/hero-sm@2x.webp")